module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/288_symbol_coin@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/288_symbol_coin@3x.png
// module id = 676
// module chunks = 0